import { create } from 'zustand';

interface IFeedbackModalState {
  isOpen: boolean;
  open(): void;
  close(): void;
  subject: string;
  setSubject(value: string): void;
}

const useFeedbackModalStore = create<IFeedbackModalState>()((set, get) => ({
  isOpen: false,
  subject: '',
  open() {
    set(state => ({ isOpen: true }));
  },
  close() {
    set(state => ({ isOpen: false }));
  },
  setSubject(value) {
    set(state => ({ subject: value }));
  }
}));

export default useFeedbackModalStore;
